module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("6Ncmn"))).then(() => parcelRequire('5erN3'));